import { addSearchTextToHistory } from './searchHistory';
import { dispatch } from 'nike-re-framejs';
import { SEARCH_RESULT_MIN_SIZE } from '@/common/constants';
import { SEARCH_RESULTS } from '@/routing/routes';
import { navigate } from '@/routing';
import { fireGAEvent } from '@/analytics';

export function submitSearch(searchText) {
    dispatch(['ui.hideSection', 'searchAutoSuggest']);
    dispatch(['ui.hideSection', 'searchBox']);
    dispatch(['ui.hideSection', 'searchDesktop']);
    navigate(SEARCH_RESULTS, { searchText });
    addSearchTextToHistory(searchText);
    fireGAEvent('Vyhladavanie', 'Hladany vyraz', searchText);
}

export const isSearchTextLengthInsufficient = searchText => searchTextLength(searchText) < SEARCH_RESULT_MIN_SIZE;

const searchTextLength = searchText =>
    searchText
        .split(/\s/)
        .filter((elem, pos, arr) => arr.indexOf(elem) === pos) //unique
        .map(part => part.length)
        .reduce((a, b) => a + b, 0);
